import Model from './Model'

export default class Recommendation extends Model {
  static entity = 'recommendation'

  static fields () {
    return {
      id: this.attr(null),
      account_id: this.attr(undefined),
      type: this.attr(undefined),
      data: this.attr(undefined),
      loading: this.attr(undefined),
      created_at: this.attr(undefined)
    }
  }

  // fresh: true also bypasses the server's 2-minute formula cache (?fresh=1) — use it
  // after mutating the data a section counts, otherwise the recomputed counts can lag
  // behind the list by up to two minutes. It skips multiplexing/request-reuse on purpose:
  // a multiplexed request runs with the first caller's options, and reuseRequest could
  // hand back an in-flight cached response.
  static async refresh (id, { fresh = false } = {}) {
    const record = this.find(id)
    if (record) {
      this.update({
        where: id,
        data: {
          loading: true
        }
      })
    } else {
      this.insert({
        data: {
          id,
          loading: true
        }
      })
    }
    try {
      const result = await this.fetchOne(
        id,
        {
          force: true,
          ...(fresh
            ? {
                noReuse: true,
                request: {
                  hideErrors: true,
                  params: {
                    fresh: 1
                  }
                }
              }
            : {
                multiplex: true,
                request: {
                  hideErrors: true
                }
              }
          )
        }
      )

      return result
    } finally {
      this.update({
        where: id,
        data: {
          loading: false
        }
      })
    }
  }
}
